import { render, staticRenderFns } from "./FoundryExchangeInput.vue?vue&type=template&id=2bbf29a4&"
import script from "./FoundryExchangeInput.vue?vue&type=script&lang=ts&"
export * from "./FoundryExchangeInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports